import { useUser } from '../../hooks/useUser/useUser';
import { Loading } from '../Loading/Loading';
import { Totals } from '../Totals/Totals';
import { SummaryBanner } from '../SummaryBanner/SummaryBanner';
import { Trends } from '../Trends/Trends';
import { useAuth } from '../../hooks/useAuth/useAuth';

export const Summary = () => {
  const { user } = useAuth();
  const { userData, mood, isUserLoading } = useUser();
  const name = user?.firstName || userData?.shortName;

  return !isUserLoading ? (
    <>
      <SummaryBanner
        averageMood={mood?.averageMood}
        firstName={name}
        totalDistance={userData?.totalDistance}
      />

      <Trends activities={userData?.activities} />

      <Totals userData={userData} />
    </>
  ) : (
    <Loading />
  );
};
